import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { prop } from 'ramda';

import { stateSelector } from './state';

export const filterSelector = createDraftSafeSelector(stateSelector, prop('filter'));
